var DetailsDisclosure = window.DetailsDisclosure;

if (!DetailsDisclosure) {
  DetailsDisclosure = class DetailsDisclosure extends HTMLElement {
    constructor() {
      super();

      this.mainDetailsToggle = this.querySelector('details');

      if (!this.mainDetailsToggle) return;

      const summary = this.mainDetailsToggle.querySelector('summary');
      if (!summary) return;

      this.content = summary.nextElementSibling;

      this.mainDetailsToggle.addEventListener(
        'focusout',
        this.onFocusOut.bind(this)
      );

      this.mainDetailsToggle.addEventListener(
        'toggle',
        this.onToggle.bind(this)
      );
    }

    onFocusOut() {
      setTimeout(() => {
        if (!this.contains(document.activeElement)) this.close();
      });
    }

    onToggle() {
      if (!this.content) return;

      if (!this.animations) {
        this.animations = this.content.getAnimations();
      }

      if (this.mainDetailsToggle.open) {
        this.animations.forEach((animation) => animation.play());
      } else {
        this.animations.forEach((animation) => animation.cancel());
      }
    }

    close() {
      if (!this.mainDetailsToggle) return;

      this.mainDetailsToggle.removeAttribute('open');

      const summary =
        this.mainDetailsToggle.querySelector('summary');

      if (summary) {
        summary.setAttribute('aria-expanded', 'false');
      }
    }
  };

  window.DetailsDisclosure = DetailsDisclosure;
}

if (!customElements.get('details-disclosure')) {
  customElements.define('details-disclosure', DetailsDisclosure);
}

if (!customElements.get('header-menu')) {
  class HeaderMenu extends DetailsDisclosure {
    constructor() {
      super();
      this.header = document.querySelector('.header-wrapper');
    }

    onToggle() {
      if (!this.header || !this.mainDetailsToggle) return;

      this.header.preventHide = this.mainDetailsToggle.open;

      if (
        document.documentElement.style.getPropertyValue(
          '--header-bottom-position-desktop'
        ) !== ''
      ) {
        return;
      }

      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }
  }

  customElements.define('header-menu', HeaderMenu);
}